<div class="side-sheet side-sheet-details response-details" [ngClass]="{'active': selectedRecordId}">
  <div class="d-flex h-100">

    <div class="overlay" (click)="close.emit()"></div>

    <div class="sheet-container">
      <div class="sheet-head d-block p-0">
        <div class="head">
          <div class="title">
            {{'surveyTasks.surveyResponseDetails' | translate}}
          </div>
          <a (click)="close.emit()">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
              <path id="ic_close"
                d="M213.746-744.393l-6.441,6.436a1.459,1.459,0,0,1-1.063.457,1.406,1.406,0,0,1-1.046-.457,1.418,1.418,0,0,1-.45-1.054,1.449,1.449,0,0,1,.45-1.037l6.441-6.452-6.441-6.452a1.419,1.419,0,0,1-.441-1.037,1.473,1.473,0,0,1,.441-1.053,1.406,1.406,0,0,1,1.046-.457,1.485,1.485,0,0,1,1.063.441l6.441,6.452,6.458-6.452a1.431,1.431,0,0,1,1.046-.441,1.458,1.458,0,0,1,1.063.457,1.443,1.443,0,0,1,.433,1.053,1.448,1.448,0,0,1-.45,1.037l-6.441,6.452,6.441,6.452a1.419,1.419,0,0,1,.441,1.037,1.473,1.473,0,0,1-.441,1.054,1.406,1.406,0,0,1-1.046.457,1.406,1.406,0,0,1-1.046-.457Z"
                transform="translate(-204.746 755.5)" fill="#8e8fa2" />
            </svg>
          </a>
        </div>
      </div>
      <ng-container *ngIf="!dataLoading">
        <div class="sheet-content">
          <div class="sheet-top-info p-0">
            <h2 class="title">
              <span dir="ltr">{{details.responseNumber}}</span>
            </h2>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-12 mb-4">
              <div class="date_time_date w-100">
                <span>
                  {{'surveyTasks.responseEntryDate' | translate}}
                </span>
                <p>
                  {{details.submittedDate| date:'d MMM yyyy - h:mm a'}}
                </p>
              </div>
            </div>
          </div>
          <div class="response-info-card">
            <div class="card-header">
              {{'surveyTasks.surveyParticipantData' | translate}}
            </div>
            <div class="card-body">
              <div class="info-group">
                <span class="label">{{'surveyTasks.name' | translate}}</span>
                <div class="value">{{details.respondentsName}}</div>
              </div>
              <div class="info-group">
                <span class="label">{{'surveyTasks.age' | translate}}</span>
                <div class="value">{{details.respondentsAge}}</div>
              </div>

              <div class="info-group">
                <span class="label">{{'manageSurveys.gender' | translate}}</span>
                <div class="value">
                <app-surveys-requests-target-audience-gender
                  [target]="details.respondentsGender"></app-surveys-requests-target-audience-gender>


                </div>
              </div>

              <div class="info-group mb-0">
                <span class="label">{{'surveyTasks.region' | translate}}</span>
                <div class="value">{{details.respondentsRegion}}</div>
              </div>
            </div>
          </div>
          <h5 class="title_has_count">
            <strong>
            </strong> {{'voting.Answers' | translate}}
          </h5>

          @if (details.answers && details.answers.length) {
          @for (question of details.answers; track question.questionId) {
          <div class="card_queestion_answer">
            <h6 class="card_title">
              @switch (question.questionTypeCode) {
              @case (QuestionTypeCodeEnum.Text_Area) {
              <img src="./assets/images/question-icons/text_box_ic.png" alt="">
              }
              @case (QuestionTypeCodeEnum.Single_Choice) {
              <img src="./assets/images/question-icons/radio_button_ic.png" alt="">
              }
              @case (QuestionTypeCodeEnum.Star_Rating) {
              <img src="./assets/images/icons/starRating.png" alt="">
              }
              @case (QuestionTypeCodeEnum.Multiple_Choice) {
              <img src="./assets/images/question-icons/checkbox_ic.png" alt="">
              }
              }
              {{question.questionType}}


            </h6>
            <p class="card_description">
              {{question.questionTitle}}
            </p>

            <h6 class="card_title">
              <span class="card_badge">
                {{"evaluationTasks.answer"|translate}}
              </span>
            </h6>
            @if (!question.textAnswer && !question.selectedOptionText && !question.selectedOptionTexts.length &&
            !question.starRating) {

            <p class="card_description text-answer">
              {{"surveyTasks.none" | translate}}
            </p>
            }
            @if (question.textAnswer && question.questionTypeCode != QuestionTypeCodeEnum.Star_Rating)
            {

                <p class="card_description text-answer" [innerText]="question.textAnswer"></p>
            }
            @if (question.questionTypeCode == QuestionTypeCodeEnum.Single_Choice)
            {
            <p class="card_description text-answer">
              {{question.selectedOptionText}}
            </p>
            }
            @if (question.questionTypeCode == QuestionTypeCodeEnum.Multiple_Choice)
            {
            <div class="card_description text-answer">
              <div *ngFor="let item of question.selectedOptionTexts">
                <img class="check" src="./assets/images/question-icons/check_grey.png" alt=""> {{item}}
              </div>
            </div>
            }
            @if (question.questionTypeCode == QuestionTypeCodeEnum.Star_Rating && question.starRating)
            {
            <p class="card_description text-answer">
              <strong>{{question.starRating}}</strong>
              {{"general.from" |translate}}
              <strong>5</strong>
            </p>
            }
            @if (question.starRating)
            {
            <p class="card_description">
              <span class="star_rating blue">
                <mat-icon *ngFor="let star of [1,2,3,4,5]" class="star_icon "
                  [class.filled]="star <= (question.starRating || 0)">
                  {{ star <= (question.starRating || 0) ? 'star' : 'star_border' }} </mat-icon>
              </span>
            </p>
            }
            @if (question.attachmentUrls && question.attachmentUrls.length)
            {
            <p class="card_description">
              <app-files-viewer [files]="question.attachmentUrls"></app-files-viewer>
            </p>
            }
            <!-- <p class="card_description">
              <span class="badge-status light">
                <span>{{"productEvaluationTasks.criteriaWeightBasedOnAnswer" | translate}} :</span> {{
                question.weightedScore}} %
              </span>
            </p> -->
          </div>
          }

          }
        </div>

        <div class="sheet-actions d-block" *ngIf="details.canDelete">
          <div class="d-flex align-items-center">
            <div class="big">
              <button mat-button class="mat-danger w-100" (click)="deleteRecord()">
                <span>{{'surveyTasks.deleteResponse' | translate}}</span>
              </button>
            </div>
          </div>
        </div>
      </ng-container>

      <div *ngIf='dataLoading' class="dataLoading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
      </div>
    </div>
  </div>
</div>
